import React from "react";
import { useCallback } from "react";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import MainLayout from "../../../components/Common/MainLayout/MainLayout";
import Input from "../../../components/Common/ReactForm/Input/Input";
import {
  getDefaultShotClassInformationActionHandler,
  getSearchClassNameActionHandler,
  getSearchUserGroupActionHandler,
} from "../../../store/actions/actionHandlers/reportActionHandler";
import { analyticalReport } from "../../../utils/mainTabs/reports/analyticalReport";
import classes from "./AnalyticalReportPage.module.scss";
import Button from "../../../components/Common/Button/Button";
import ReportGraph from "../ReportGraph/ReportGraph";
import ReportGraphFilterLayout from "../ReportGraphFilterLayout/ReportGraphFilterLayout";
import { useNavigate, useOutletContext } from "react-router";
// let chartColorsMonths = ["#49F54F", "#DAA520", "#1490BE"];

const AnalyticalReport = () => {
  const reportState = useSelector((state) => state.reportReducer);
  const { defaultShotClassInformation } = reportState;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { navLinks, inputField, graphs } = analyticalReport;
  const [classId, setClassId] = useState(0);
  const [userGroupId, setUserGroupId] = useState(0);
  const [searchClassTagsList, setSearchClassTagsList] = useState([]);
  const [searchGroupTagsList, setSearchGroupTagsList] = useState([]);

  const [trainingType, setTrainingType] = useState();
  const [rating, setRating] = useState();
  const [media, setMedia] = useState();
  const [trainingStatus, setTrainingStatus] = useState();
  const [mediaCount, setMediaCount] = useState();

  const chartColors = [
    "#1f77b4",
    "#ff7f0e",
    "#2ca02c",
    "#d62728",
    "#9467bd",
    "#8c564b",
    "#e377c2",
    "#7f7f7f",
    "#bcbd22",
    "#17becf",
  ];
  const onClassSearch = useCallback(
    (e) => {
      let val = e.target.value.trim() !== "" && e.target.value;
      if (val) {
        dispatch(
          getSearchClassNameActionHandler(
            e.target.value,
            setSearchClassTagsList
          )
        );
      } else {
        setSearchClassTagsList([]);
      }
    },
    [dispatch]
  );
  const onUserGroupSearch = useCallback(
    (e) => {
      let val = e.target.value.trim() !== "" && e.target.value;
      if (val) {
        dispatch(
          getSearchUserGroupActionHandler(
            e.target.value,
            setSearchGroupTagsList
          )
        );
      } else {
        setSearchGroupTagsList([]);
      }
    },
    [dispatch]
  );
  useEffect(() => {
    dispatch(getDefaultShotClassInformationActionHandler());
  }, [dispatch]);

  // let offline = [];

  let offline = defaultShotClassInformation?.filter((e) => e.OffLine === true);
  let online = defaultShotClassInformation?.filter((e) => e.OffLine === false);
  let quiz = defaultShotClassInformation?.filter((e) => e.Quiz === true);
  let noQuiz = defaultShotClassInformation?.filter((e) => e.Quiz === false);
  let pdf = defaultShotClassInformation?.filter((e) => e.Media === "Pdf");
  let ppt = defaultShotClassInformation?.filter((e) => e.Media === "Ppt");
  let youTube = defaultShotClassInformation?.filter(
    (e) => e.Media === "Youtube"
  );
  let video = defaultShotClassInformation?.filter((e) => e.Media === "Video");
  let html = defaultShotClassInformation?.filter((e) => e.Media === "HTML5");
  let scorm = defaultShotClassInformation?.filter((e) => e.Media === "SCORM");
  let slideShare = defaultShotClassInformation?.filter(
    (e) => e.Media === "Slideshare"
  );
  let onlineCourses = defaultShotClassInformation?.filter(
    (e) => e.Media === "OnlineCourses"
  );
  let na = defaultShotClassInformation?.filter((e) => e.Media === "NA");
  let a = defaultShotClassInformation?.filter((e) => e.TTName === "a");
  let aa = defaultShotClassInformation?.filter((e) => e.TTName === "aa");
  let hhjj = defaultShotClassInformation?.filter(
    (e) => e.TTName === "hh  jhhjh"
  );

  let others = defaultShotClassInformation?.filter(
    (e) => e.TTName !== "a" && e.TTName !== "aa" && e.TTName !== "hh  jhhjh"
  );

  let five = defaultShotClassInformation?.filter((e) => e.Rating === 5);
  let four = defaultShotClassInformation?.filter((e) => e.Rating === 4);
  let three = defaultShotClassInformation?.filter((e) => e.Rating === 3);
  let two = defaultShotClassInformation?.filter((e) => e.Rating === 2);

  let completed = defaultShotClassInformation?.filter((e) => e.Status === 3);
  let inProgress = defaultShotClassInformation?.filter((e) => e.Status === 2);
  let notStartedYet = defaultShotClassInformation?.filter(
    (e) => e.Status === 4
  );
  let recalled = defaultShotClassInformation?.filter((e) => e.Status === 5);

  let completedAfterDeadline = defaultShotClassInformation?.filter(
    (e) => e.CompletedAfterDeadline === 0
  );
  let completedInTime = defaultShotClassInformation?.filter(
    (e) => e.CompletedInTime === 1
  );
  let missedDealine = defaultShotClassInformation?.filter(
    (e) => e.MissedDeadline === 0
  );

  function getUnique(arr, comp) {
    // store the comparison  values in array
    const unique = arr
      .map((e) => e[comp])

      // store the indexes of the unique objects
      .map((e, i, final) => final.indexOf(e) === i && i)

      // eliminate the false indexes & return unique objects
      .filter((e) => arr[e])
      .map((e) => arr[e]);

    return unique;
  }

  useEffect(() => {
    setTrainingType(
      defaultShotClassInformation
        ?.map((e) => e.TTName)
        .filter(
          (value, index) =>
            defaultShotClassInformation
              ?.map((e) => e.TTName)
              ?.indexOf(value) === index
        )
    );

    setRating(
      defaultShotClassInformation
        ?.map((e) => e.Rating)
        .filter(
          (value, index) =>
            defaultShotClassInformation
              ?.map((e) => e.Rating)
              ?.indexOf(value) === index
        )
        ?.filter((e) => e !== null)
        .sort()
        .reverse()
    );
    // setTrainingStatus(
    //   defaultShotClassInformation
    //     ?.map((e) => e.Status)
    //     .filter(
    //       (value, index) =>
    //         defaultShotClassInformation
    //           ?.map((e) => e.Status)
    //           ?.indexOf(value) === index
    //     )
    //     ?.map((f) =>
    //       f === 3
    //         ? "Completed"
    //         : f == 2
    //         ? "InProgress"
    //         : f === 4
    //         ? "NotStartedYet"
    //         : f === 5
    //         ? "ReCalled"
    //         : ""
    //     )
    // );
    setMedia(
      defaultShotClassInformation
        ?.map((e) => e.Media)
        .filter(
          (value, index) =>
            defaultShotClassInformation?.map((e) => e.Media)?.indexOf(value) ===
            index
        )
    );
  }, [defaultShotClassInformation]);

  const shotclassPropertiesData = {
    labels: ["Online", "No Quiz", "Quiz", "Offline"],
    datasets: [
      {
        data: [
          getUnique(online, "ClassId").length,
          getUnique(noQuiz, "ClassId").length,
          getUnique(quiz, "ClassId").length,
          getUnique(offline, "ClassId").length,
        ],
        backgroundColor: chartColors,
      },
    ],
  };
  const contentTypeData = {
    labels: media,
    datasets: [
      {
        data: [
          getUnique(pdf, "ClassId").length,
          getUnique(ppt, "ClassId").length,
          getUnique(youTube, "ClassId").length,
          getUnique(video, "ClassId").length,
          getUnique(na, "ClassId").length,
          getUnique(scorm, "ClassId").length,
          getUnique(slideShare, "ClassId").length,
          getUnique(onlineCourses, "ClassId").length,
          getUnique(html, "ClassId").length,
        ],
        backgroundColor: chartColors,
      },
    ],
  };
  const trainingTypeData = {
    // labels: ["a", "aa", "hh jjjj", "Others"],
    labels: [trainingType],
    datasets: [
      {
        data: [
          getUnique(a, "ClassId").length,
          getUnique(aa, "ClassId").length,
          getUnique(hhjj, "ClassId").length,
          getUnique(others, "ClassId").length,
        ],
        backgroundColor: ["#1f77b4", "#ff7f0e", "#2ca02c", "#d62728"],
      },
    ],
  };
  const ratingData = {
    // labels: ["a", "aa", "hh jjjj", "Others"],
    labels: rating,
    datasets: [
      {
        data: [
          getUnique(five, "ClassId").length,
          getUnique(four, "ClassId").length,
          getUnique(three, "ClassId").length,
          getUnique(two, "ClassId").length,
        ],
        backgroundColor: ["#1f77b4", "#ff7f0e", "#2ca02c", "#d62728"],
      },
    ],
  };

  const trainingStatusData = {
    // labels: ["a", "aa", "hh jjjj", "Others"],
    labels: ["Completed", "InProgress", "NotStartedYet", "ReCalled"],
    datasets: [
      {
        data: [
          completed.length,
          inProgress.length,
          notStartedYet.length,
          recalled.length,
        ],
        backgroundColor: ["#1f77b4", "#ff7f0e", "#2ca02c", "#d62728"],
      },
    ],
  };

  const deadlineData = {
    // labels: ["a", "aa", "hh jjjj", "Others"],
    labels: ["CompletedAfterDeadline", "CompletedInTime", "MissedDeadlines"],
    datasets: [
      {
        data: [
          getUnique(completedAfterDeadline, "ClassId").length,
          getUnique(completedInTime, "ClassId").length,
          getUnique(missedDealine, "ClassId").length,
        ],
        backgroundColor: ["#1f77b4", "#ff7f0e", "#2ca02c"],
      },
    ],
  };

  let graphData = graphs(
    shotclassPropertiesData,
    contentTypeData,
    trainingTypeData,
    ratingData,
    trainingStatusData
  );

  const [formData, setFormdata] = useState([]);

  useEffect(() => {
    let formArgs = {
      onClassSearch,
      onUserGroupSearch,
      searchClassTagsList,
      searchGroupTagsList,
      setClassId,
      setUserGroupId,
    };
    let data = inputField(formArgs);
    setFormdata(data);
  }, [searchClassTagsList, searchGroupTagsList]);

  const { tenantName } = useOutletContext();

  return (
    <>
      <MainLayout navLinks={navLinks(navigate, tenantName)}>
        <ReportGraphFilterLayout inputField={formData} graphs={graphData} />
      </MainLayout>

      {/* <ReportGraphFilterLayout graphs={graphData} /> */}
    </>
  );
};

export default AnalyticalReport;
